/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../Loading/LoadingSlice'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  notification: {},
  system: [],
  portal: [],
  allNotifications: [],
  unapprovedNotification: {},
}

export type PortalNotificationItem = {
  _id: string
  notificationType?: string
  createdAt?: string
  updatedAt?: string
  notificationDetails?: {
    rawContactId?: string
  }
}

export type NotificationState = {
  notification?: {
    portal?: PortalNotificationItem[]
  }
}
export const GetAllDataSysdata: any = createAsyncThunk(
  'GetAllDataSysdata',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}notification`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data?.data?.filter((val: any) => val?.type == 'system')
  }
)
export const GetAllDataport: any = createAsyncThunk('GetAllDataport', async (data, thunkApi) => {
  const response = await axios.get(`${API_URL}notification`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  return response.data?.data?.filter((val: any) => val?.type == 'inbox')
})

export const GetAllNotification: any = createAsyncThunk(
  'GetAllNotification',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}notification/all`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response.data?.data
  }
)

export const readNotification: any = createAsyncThunk(
  'readNotification',
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}notification/markread`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(GetAllDataSysdata())
    thunkApi.dispatch(GetAllDataport())
    return response.data
  }
)

export const unapprovedNotification: any = createAsyncThunk(
  'unapprovedNotification',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}notification/unapproved`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response.data
  }
)

const Notification = createSlice({
  name: 'Notification',
  initialState,
  reducers: {
    systemNotification: (state, {payload}) => {
      // (state?.system?.filter((val:any)=>val._id===payload._id)?.length==0) ?{...state,system:[...state.system,payload]}:{...state,system:[...state.system]}
      return {...state, system: payload}
    },
    portalNotification: (state, {payload}) => {
      // (state?.system?.filter((val:any)=>val._id===payload._id)?.length==0) ?{...state,system:[...state.system,payload]}:{...state,system:[...state.system]}
      return {...state, portal: payload}
    },
    readNotification: (state, {payload}) => {
      return {...state, system: [...state.system, payload]}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetAllDataSysdata.fulfilled, (state, action) => {
      return {...state, system: action?.payload}
    })
    builder.addCase(GetAllDataport.fulfilled, (state, action) => {
      return {...state, portal: action?.payload}
    })
    builder.addCase(GetAllNotification.fulfilled, (state, action) => {
      return {...state, allNotifications: action?.payload}
    })
    builder.addCase(unapprovedNotification.fulfilled, (state, action) => {
      return {...state, unapprovedNotification: action?.payload}
    })
  },
})

export const {systemNotification} = Notification.actions
export const {portalNotification} = Notification.actions

export const getAllNotifications = (state: any) => state.notification.allNotifications

export default Notification.reducer

